/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h1[_ngcontent-%COMP%]{font-size:12rem!important}@media (max-width:640px){h1[_ngcontent-%COMP%]{font-size:6rem!important}}"];
export { styles as styles };
